export default __webpack_public_path__ + "static/media/number-shine-9.0f761af9.svg";